export default "__VITE_ASSET__Bl$oaZEa__"